/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropstartsat2Inputs */

const en_dropstartsat2 = /** @type {(inputs: Dropstartsat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts at`)
};

const de_dropstartsat2 = /** @type {(inputs: Dropstartsat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Starts at" |
*
* @param {Dropstartsat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropstartsat2 = /** @type {((inputs?: Dropstartsat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropstartsat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropstartsat2(inputs)
	return de_dropstartsat2(inputs)
});
export { dropstartsat2 as "dropStartsAt" }